'use strict'

export default class Bdsg {
    constructor() {
        this.content = $('#bdsg');
    }
    init() {
        this.content.find('.show').click(() => {
            this.content.toggleClass('active');
        });
        this.content.find('.exit').click(() => {
            this.content.removeClass('active');
        });
        this.content.find('#deactivateCookies').click((e) => {
            if (e.currentTarget.checked) {
                window.staticEvents.emit('deactivateCookies');
            } else {
                window.staticEvents.emit('activateCookies');
            }
        });
        this.content.find('#deactivateMatomo').click((e) => {
            if (e.currentTarget.checked) {
                window.staticEvents.emit('deactivateMatomo');
            } else {
                window.staticEvents.emit('activateMatomo');
            }
        });
    }
    append() {
    }
}
